// Style
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { TUserDTO } from "Types";
import { LetteredUserCircle } from "../LetteredUserCircle";
import styles from "./user.module.scss";

type TUserProps = {
    user: TUserDTO,
    className?: string,
    roleClassName?: string,
    onClick?: (user: TUserDTO) => void,
    onRemoveClick?: (user: TUserDTO) => void
}

export const User: FC<TUserProps> = ({user, className, roleClassName, onClick, onRemoveClick}: TUserProps) => {

    const onUserClick = () => {
        if(!onClick) return;

        onClick(user);
    };

    const onUserRemoveClick = () => {
        if(!onRemoveClick) return;

        onRemoveClick(user);
    };

    return (
        <div className={`${styles.user} ${className ? className : ""}`} onClick={onUserClick}>
            <div className={styles.userInfo}>
                <LetteredUserCircle username={user.email} className={styles.letteredUserCircle}/>
                <span className={styles.email}>{user.email}</span>
            </div>
            {// TODO: create a get main role function 
            }
            <div className={styles.userRole}>
                <span className={`${styles.role} ${roleClassName ? roleClassName : ""}`}>{user.roles[0]}</span>
                {onRemoveClick ?
                    <div className={styles.trash} onClick={onUserRemoveClick}>
                        <FontAwesomeIcon icon={faTrash} />
                    </div>
                    : null}
            </div>
        </div>
    );
};